import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import SweetAlert from 'sweetalert-react';
import SearchInput from 'components/SearchModal/SearchInput';

import {
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
} from 'C4';
import { storageKeys, bgVideo } from 'settings';

import 'react-toastify/dist/ReactToastify.css';
import Logo from 'assets/images/logo/logo_white.png';
import Logo2 from 'assets/images/logo/logo.png';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '',
      appId: -1,
      userStatus: 'startTraining',
      passport: false,
    };
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        if (res.training_graduated) {
          return this.setState({ userStatus: 'graduated' });
        }
        if (res.training_started) {
          return this.setState({ userStatus: 'continueTraining' });
        }
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);

    StorageHandler.load(storageKeys.user).then((user) => {
      if (user && user.sales_companion_registered === null) {
        const obj = user;
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(
          d.getDate()
        )}`;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.updateUser(appId, obj.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        });
      }
    });
    // DataHandler.matchAppId().then((appId) => {
    //   this.setState({ appId });
    //   StorageHandler.exists(storageKeys.announcement).then((announcementShownBefore) => {
    //     if (!announcementShownBefore) {
    //       APIHandler.getAnnouncement(appId).then((res) => {
    //         const TaostContent = () => (
    //           <div>
    //             <p>
    //               {res.copy}
    //               <a
    //                 data-fancybox="rewards"
    //                 data-type="iframe"
    //                 data-src={`https://perurewards.travpromobile.com/?app_id=${appId}`}
    //                 href={res.link}
    //                 key="rewards"
    //               >
    //                 {i18n.translate('general.rewards')}
    //               </a>
    //             </p>
    //           </div>
    //         );

    //         if (res.length !== 0) {
    //           toast.info(TaostContent, {
    //             position: 'top-center',
    //             autoClose: false,
    //             closeOnClick: true,
    //             transition: Zoom,
    //             hideProgressBar: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             toastId: 'announcement',
    //             onClose: () =>
    //               StorageHandler.save(
    //                 storageKeys.announcement,
    //                 res.copy,
    //                 604800,
    //               ), // expires in a week
    //           });
    //         }
    //         return null;
    //       });
    //     }
    //   });
    // });

    const ToastContent = () => (
      <div>
        <p>
          <a
            key="toast"
            onClick={() => {
              // Show sweetalert
              this.setState({ passport: true });
            }}
          >
            Lauderdale Loyalists VIP Passport. Click here to learn more.
          </a>
        </p>
      </div>
    );

    toast.info(ToastContent, {
      position: 'bottom-right',
      autoClose: false,
      closeOnClick: false,
      transition: Zoom,
      hideProgressBar: true,
      pauseOnHover: true,
      draggable: false,
      toastId: 'announcement',
    });
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      this.state.lastCheckedMessages
    ).then((res) => {
      if (res && res.missed_items && res.missed_items[0]) {
        this.setState({ unreadMessageCount: res.missed_items[0].count });
      }
    });
  }

  render() {
    const { unreadMessageCount, appId, userStatus, passport } = this.state;

    const close = () => {
      this.setState({
        passport: false,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo />}
        <div className="bgHome" />
        <div className="buttonWrapper">
          Download now:
          <StoreButtons />
        </div>
        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {(props) => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                <img src={`/${Logo}`} className="homeLogo" alt="logo" />
                <div className="homeView__title--action">
                  <SearchInput />
                  <div className="homepage__buttons">
                    <Link to="/main/messages" className="startTrain">
                      <FontAwesomeIcon icon={['fas', 'envelope']} />
                      {unreadMessageCount === 0 && (
                        <p>{i18n.translate('nav.messages')}</p>
                      )}
                      {unreadMessageCount > 0 && (
                        <p>
                          {i18n.translate(
                            `${
                              unreadMessageCount === 1
                                ? 'general.message'
                                : 'general.messagePlural'
                            }`,
                            { count: unreadMessageCount }
                          )}
                        </p>
                      )}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Spring>
        <div className="top-bar" />
        <div className="bottom-bar" />
        <SweetAlert
          title="Lauderdale Loyalist Passport:"
          show={passport}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text="
          Advisors, we welcome you to experience Greater Fort Lauderdale. As a thank you for your loyalty, we're offering advisors that graduate as a Lauderdale Loyalist access to this exclusive passport.
          <br /><br />
          The Lauderdale Loyalist Passport is a collection of curated cruises, museums, outdoor adventures and more offering deals and discounts to redeem during your visit. Graduate first, that will unlock your exclusive tile in the <a href='/main/sell'>SELL section</a>, where you can then go verify your IATA / CLIA numbers for access.
          <br /><br />
          Already a graduate? Head <a href='https://www.visitlauderdale.com/loyalistpass/verification/' target='_blank'>here</a> now to verify your IATA number and eligibility. You will then receive additional instructions on how to redeem your Lauderdale Loyalist Passport.
          <br /><br />
          <b>ENJOY!</b>"
          customClass="passport"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        />
        <ToastContainer
          draggablePercent={60}
          autoClose={false}
          newestOnTop
          rtl={false}
          pauseOnVisibilityChange
          draggable
        />
      </div>
    );
  }
}
